/** @format */

//Selectors
export const signedIn = (state): String => state.auth.signedIn;
export const token = (state): String => state.auth.token;
export const refresh_token = (state): String => state.auth.refresh_token;
